var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchiveIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0965 6.59647L20.7865 3.28651C20.5801 3.07901 20.2998 2.96313 20.0062 2.96313H6.76192C6.46834 2.96313 6.188 3.07901 5.98161 3.28651L2.67165 6.59647C2.47078 6.79624 2.34717 7.07216 2.34717 7.37788V21.7258C2.34717 22.9432 3.33718 23.9332 4.55454 23.9332H22.2136C23.4309 23.9332 24.4209 22.9432 24.4209 21.7258V7.37788C24.4209 7.07216 24.2973 6.79624 24.0965 6.59647ZM7.21885 5.1705H19.5493L20.6529 6.27419H6.11516L7.21885 5.1705ZM4.55454 21.7258V8.48157H22.2136L22.2158 21.7258H4.55454Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5911 10.6889H11.1763V14H7.86523L13.3837 19.5185L18.9021 14H15.5911V10.6889Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveIcon);
export default __webpack_public_path__ + "static/media/archive-icon.19e6421971d86d3ca67c80c6d1518331.svg";
export { ForwardRef as ReactComponent };